/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EmailClickIcon = ({
  className,
  style: styleFromProps,
  color = '#BFBFBF',
  onClick,
  size,
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={classNames(className)}
      onClick={onClick}
    >
      <g clipPath="url(#clip0_10131_130698)">
        <path
          d="M8.69988 16.6497C8.67405 16.6497 8.64781 16.6478 8.62144 16.644C8.41859 16.6135 8.25111 16.4686 8.19215 16.2718L5.01221 5.67202C4.9563 5.48546 5.00731 5.28301 5.14524 5.14508C5.28343 5.00715 5.48708 4.95587 5.67218 5.01205L16.272 8.19199C16.4686 8.25095 16.6136 8.41843 16.6442 8.62128C16.6745 8.8244 16.5847 9.02686 16.4139 9.14067L13.772 10.902L16.4947 13.6249C16.7018 13.832 16.7018 14.1674 16.4947 14.3743L14.3748 16.4943C14.1677 16.7014 13.8323 16.7014 13.6253 16.4943L10.9024 13.7716L9.1411 16.4135C9.04173 16.5625 8.87531 16.6497 8.69988 16.6497ZM10.8198 12.4098C10.9599 12.4098 11.0946 12.4652 11.1945 12.5651L13.9998 15.3703L15.3702 13.9998L12.5651 11.1945C12.4527 11.0822 12.3968 10.9257 12.4125 10.7675C12.428 10.6097 12.5137 10.4667 12.6459 10.3787L14.8886 8.88376L6.31069 6.31039L8.88405 14.8883L10.379 12.6456C10.467 12.5134 10.6098 12.4277 10.7678 12.4122C10.7851 12.4106 10.8025 12.4098 10.8198 12.4098ZM3.77468 3.77465C3.98178 3.56756 3.98178 3.23221 3.77468 3.02525L2.7147 1.96527C2.50761 1.75817 2.17226 1.75817 1.9653 1.96527C1.75834 2.17236 1.7582 2.50771 1.9653 2.71467L3.02528 3.77465C3.12876 3.87813 3.2643 3.92994 3.39998 3.92994C3.53566 3.92994 3.6712 3.87813 3.77468 3.77465ZM3.39998 5.51991C3.39998 5.22722 3.16268 4.98992 2.86999 4.98992H1.28002C0.987334 4.98992 0.750031 5.22722 0.750031 5.51991C0.750031 5.8126 0.987334 6.0499 1.28002 6.0499H2.86999C3.16268 6.0499 3.39998 5.8126 3.39998 5.51991ZM2.7147 9.07456L3.77468 8.01457C3.98178 7.80748 3.98178 7.47213 3.77468 7.26517C3.56759 7.05821 3.23224 7.05808 3.02528 7.26517L1.9653 8.32515C1.7582 8.53224 1.7582 8.86759 1.9653 9.07456C2.06878 9.17804 2.20432 9.22984 2.34 9.22984C2.47568 9.22984 2.61122 9.17804 2.7147 9.07456ZM8.01461 3.77465L9.07459 2.71467C9.28168 2.50758 9.28168 2.17223 9.07459 1.96527C8.86749 1.75831 8.53214 1.75817 8.32518 1.96527L7.2652 3.02525C7.05811 3.23234 7.05811 3.56769 7.2652 3.77465C7.36868 3.87813 7.50422 3.92994 7.6399 3.92994C7.77558 3.92994 7.91112 3.87813 8.01461 3.77465ZM6.04993 2.86996V1.27999C6.04993 0.987303 5.81263 0.75 5.51994 0.75C5.22725 0.75 4.98995 0.987303 4.98995 1.27999V2.86996C4.98995 3.16265 5.22725 3.39995 5.51994 3.39995C5.81263 3.39995 6.04993 3.16265 6.04993 2.86996Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10131_130698">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
